import { render, staticRenderFns } from "./DiagnosticAnswer.vue?vue&type=template&id=38c96ab4&"
import script from "./DiagnosticAnswer.vue?vue&type=script&lang=js&"
export * from "./DiagnosticAnswer.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticAnswer.vue?vue&type=style&index=0&id=38c96ab4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports